module.exports = __webpack_public_path__ + "double-anno-cn-desktop.jpg";